if (typeof CartForm !== 'function') {
	class CartForm extends HTMLElement {
		constructor() {
			super();
			this.ajaxifyCartItems();
			this.checkAvailibility();

			this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		}

		ajaxifyCartItems() {
			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach((item) => {
				const remove = item.querySelector('.remove');
				if (remove) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e) => {
						e.preventDefault();
						this.updateCartQty(item, 0);
					});
				}

				const qty = item.querySelector('.qty');
				if (qty) {
					qty.addEventListener(
						'input',
						debounce((e) => {
							e.preventDefault();
							e.target.blur();
							this.updateCartQty(item, parseInt(qty.value));
						}, 300)
					);
					qty.addEventListener('click', (e) => {
						e.target.select();
					});
				}
			});
		}

		addBusinessDays(date, days) {
			let count = 0;
			let current = new Date(date.getTime());

			while (count < days) {
				current.setDate(current.getDate() + 1);
				if (current.getDay() !== 0 && current.getDay() !== 6) {
					count++;
				}
			}

			return current;
		}

		formatDate(date) {
			const { months } = this;

			return `${months[date.getMonth()]} ${date.getDate()}`;
		}

		getFullDate(dateForLocation = false) {
			if (dateForLocation) {
				const date = dateForLocation;
				const initialDate = new Date(date);
				let firstDate = null;
				let lastDate = null;

				if (!isNaN(initialDate.getTime())) {
					firstDate = initialDate;
					lastDate = this.addBusinessDays(new Date(firstDate), 5);
				}

				if (firstDate && lastDate) {
					return `${this.formatDate(firstDate)} - ${this.formatDate(lastDate)}`;
				}

				return false;
			}
		}

		checkAvailibility() {
			const $this = this;
			$this.storeSelector = document.querySelector('store-selector');

			if (this.storeSelector) {
				document.addEventListener('DOMContentLoaded', (event) => {
					const selectedStore = localStorage.getItem('selected-store');

					if (selectedStore) {
						// Disabled: cart attributes are handled by header/footer Store Selector scripts.
						$this.checkCartAttribute();
					}
				});

				this.storeSelector.addEventListener('storechanged', (e) => {
					const selectedStore = localStorage.getItem('selected-store');

					async function fetchCartItems() {
						const response = await fetch('/cart.js');
						const cart = await response.json();
						return cart;
					}

					async function fetchBaseProduct(handle) {
						let product = null;
						const response = await fetch(`/products/${handle}?section_id=product_meta_api`)
							.then((response) => response.text())
							.then((text) => {
								const getJson = new DOMParser()
									.parseFromString(text, 'text/html')
									.getElementById('shopify-section-product_meta_api').textContent;

								if (getJson) {
									product = JSON.parse(getJson);
								}
							});

						if (product) {
							return product;
						}
					}

					async function fetchVariantSource(id) {
						let locations = null;
						const response = await fetch(`/variants/${id}?section_id=product_locations_api`)
							.then((response) => response.text())
							.then((text) => {
								const getJson = new DOMParser()
									.parseFromString(text, 'text/html')
									.getElementById('shopify-section-product_locations_api').textContent;

								if (getJson) {
									locations = JSON.parse(getJson);
								}
							});

						if (locations) {
							return locations;
						}
					}

					async function updateCartItems(keyGroups) {
						let itemsToAdd = [];
						let itemsToRemove = [];
						let type = null;
						let locationAvailable = null;
						let updates = [];
						let preOrders = [];
						let itemsToUpdate = [];

						for (const group of keyGroups) {
							const meta = group.meta;
							const shipping = meta.shipping;
							const blockedLocations = meta.blockedLocations;
							const existingItemKey = preOrders.findIndex((item) => item.key === group.key);
							let id = null;

							if (group.update) {
								id = group.pairId;
							} else {
								id = group.id;
							}

							const variantSource = await fetchVariantSource(id);

							if (variantSource.hasOwnProperty('pre-order') && variantSource['pre-order'] === true) {
								const preOrderLocations = variantSource['pre-order-locations'];
								const preOrderDates = variantSource['pre-order-dates'];

								if (preOrderLocations && preOrderDates) {
									if (existingItemKey === -1) {
										const preOrderMeta = {
											id: id,
											key: group.key,
											locations: preOrderLocations,
											dates: preOrderDates,
										};

										preOrders.push(preOrderMeta);
									}
								}
							}

							if (existingItemKey && itemsToAdd.length === 0) {
								const preOrder = preOrders.find((item) => item.key === group.key);

								let properties = [];

								if (preOrder) {
									if (preOrder.locations && preOrder.locations.length > 0) {
										const formattedLocations = preOrder.locations.map((location) =>
											location.toLowerCase().replace(/ /g, '-').replace(/,/g, '')
										);

										if (
											typeof formattedLocations !== 'undefined' &&
											formattedLocations.length > 0
										) {
											const dateIndex = formattedLocations.indexOf(selectedStore);

											if (dateIndex !== -1) {
												const dateForLocation = preOrder.dates[dateIndex];

												if (dateForLocation) {
													const fullDate = $this.getFullDate(dateForLocation);

													if (fullDate) {
														properties = {
															'Pre-Order': fullDate,
														};
													}
												}
											}
										}
									}
								}

								const key = group.key;

								itemsToUpdate.push({
									id: key.toString(),
									properties,
								});
							}

							if (variantSource.hasOwnProperty(selectedStore)) {
								let message = null;
								const locationAvailable = variantSource[selectedStore];

								if (locationAvailable) {
									if (!shipping && selectedStore === 'shipping') {
										message = `<b>${group.title}</b> is <b>unavailable</b> for Shipping. We'll remove the Product from your Cart.`;
										type = 'error';

										if (!itemsToRemove.includes(group.key)) {
											itemsToRemove.push(group.key);
										}
									} else if (
										blockedLocations &&
										blockedLocations.includes($this.storeSelector.storesList[selectedStore])
									) {
										message = `<b>${group.title}</b> is <b>unavailable</b> for Pickup at this Location. We'll remove the Product from your Cart.`;
										type = 'error';

										if (!itemsToRemove.includes(group.key)) {
											itemsToRemove.push(group.key);
										}
									} else {
										if (group.pairAvailable && group.update) {
											message = `Your cart has been updated with following method: <b>${$this.storeSelector.storesList[selectedStore]}</b>. Price for <b>${group.title}</b> has changed.`;
											type = 'info';

											if (!itemsToRemove.includes(group.key)) {
												itemsToRemove.push(group.key);
											}

											let properties = {};

											if (preOrders.length > 0) {
												const preOrder = preOrders.find((item) => item.key === group.key);

												if (preOrder) {
													if (preOrder.locations && preOrder.locations.length > 0) {
														const formattedLocations = preOrder.locations.map((location) =>
															location.toLowerCase().replace(/ /g, '-').replace(/,/g, '')
														);

														if (
															typeof formattedLocations !== 'undefined' &&
															formattedLocations.length > 0
														) {
															const dateIndex = formattedLocations.indexOf(selectedStore);

															if (dateIndex !== -1) {
																const dateForLocation = preOrder.dates[dateIndex];

																if (dateForLocation) {
																	const fullDate = $this.getFullDate(dateForLocation);

																	if (fullDate) {
																		properties = {
																			'Pre-Order': fullDate,
																		};
																	}
																}
															}
														}
													}
												}
											}

											itemsToAdd.push({
												id: group.pairId,
												quantity: group.qty || 1,
												properties,
											});
										}
									}
								} else {
									message = `<b>${group.title}</b> is <b>unavailable</b> for <b>${$this.storeSelector.storesList[selectedStore]}</b>. We'll remove the Product from your Cart.`;
									type = 'error';

									if (!itemsToRemove.includes(group.key)) {
										itemsToRemove.push(group.key);
									}
								}

								if (message) {
									$this.showToast(message, type, 10000);
								}
							}
						}

						if (itemsToRemove.length > 0) {
							const removeObject = Object.fromEntries(itemsToRemove.map((key) => [key, 0]));

							const requestOptions = {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json',
								},
								body: JSON.stringify({
									updates: removeObject,
								}),
							};

							await fetch('/cart/update.js', requestOptions);
							updates.push('cartItemsRemoved');
						}

						if (itemsToAdd.length > 0) {
							const requestOptions = {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json',
								},
								body: JSON.stringify({
									items: itemsToAdd,
								}),
							};

							await fetch('/cart/add.js', requestOptions);
							updates.push('cartItemsAdded');
						}

						// if (itemsToUpdate.length > 0) {
						// 	for (const item of itemsToUpdate) {
						// 		const itemId = item.id;
						// 		const itemProperties = item.properties;
						//
						// 		const requestOptions = {
						// 			method: 'POST',
						// 			headers: {
						// 				'Content-Type': 'application/json',
						// 			},
						// 			body: JSON.stringify({ id: itemId, properties: itemProperties }),
						// 		};
						//
						// 		await fetch('/cart/change.js', requestOptions);
						// 	}
						//
						// 	updates.push('cartItemsUpdated');
						// }

						return updates;
					}

					function createProductPair(item, matchedSKU, meta, update) {
						if (matchedSKU) {
							return {
								baseVariant: {
									key: item.key,
									available: item.available,
									qty: item.quantity,
									id: item.id,
									sku: item.sku,
									title: item.title,
								},
								pairVariant: {
									available: matchedSKU.available,
									id: matchedSKU.id,
									sku: matchedSKU.sku,
									title: matchedSKU.name,
								},
								meta: meta,
								update: update,
							};
						} else {
							return {
								baseVariant: {
									key: item.key,
									available: item.available,
									qty: item.quantity,
									id: item.id,
									sku: item.sku,
									title: item.title,
								},
								pairVariant: matchedSKU,
								meta: meta,
								update: update,
							};
						}
					}

					async function processCartItems() {
						const cart = await fetchCartItems();

						// (Removed) $this.updateCartAttribute();
						// PICK_UP / fulfillment is handled by the Store Selector scripts in theme.liquid

						let products = {};
						products['baseProducts'] = [];
						products['pairProducts'] = [];

						for (const item of cart.items) {
							const baseProduct = await fetchBaseProduct(item.handle);

							const meta = baseProduct.meta;
							const shipping = meta.shipping;
							const blockedLocations = meta.blockedLocations;
							let update = false;

							let productPair = null;
							products['baseProducts'].push(baseProduct);
							item.available = baseProduct.available;

							if (!item.product_has_only_default_variant) {
								const matchedSKU = baseProduct.variants.find(
									(variant) => variant.sku === item.sku && variant.id !== item.id
								);

								if (matchedSKU) {
									if (item.variant_options.includes('Shipping') && selectedStore !== 'shipping') {
										update = true;
									} else if (
										item.variant_options.includes('Pickup') &&
										selectedStore === 'shipping'
									) {
										update = true;
									}

									productPair = createProductPair(item, matchedSKU, meta, update);
								}
							} else {
								productPair = createProductPair(item, null, meta, null);
							}

							if (productPair) {
								products['pairProducts'].push(productPair);
							}
						}

						return products;
					}

					async function updateCart() {
						const products = await processCartItems();

						const pairProducts = products.pairProducts;
						let keyGroups = [];

						if (pairProducts.length > 0) {
							for (const pairProduct of pairProducts) {
								keyGroups.push({
									key: pairProduct['baseVariant'].key,
									qty: pairProduct['baseVariant'].qty,
									id: pairProduct['baseVariant'].id,
									meta: pairProduct.meta,
									title: pairProduct['baseVariant'].title,
									available: pairProduct['baseVariant'].available,
									pairId: pairProduct['pairVariant'] ? pairProduct['pairVariant'].id : null,
									pairTitle: pairProduct['pairVariant'] ? pairProduct['pairVariant'].title : null,
									pairAvailable: pairProduct['pairVariant']
										? pairProduct['pairVariant'].available
										: null,
									update: pairProduct.update,
								});
							}
						}

						if (keyGroups.length > 0) {
							const data = await updateCartItems(keyGroups);

							return data;
						}
					}

					updateCart().then((data) => {
						const store_selector = document.querySelector('store-selector');
						store_selector._disableCheckoutButton(false);
						store_selector._disableAddToCartButtons(false);

						if (data && data.length > 0) {
							window.refreshCart();
						}
					});
				});
			}
		}

		showToast(message, type, duration) {
			const event = new CustomEvent('show-toast', {
				detail: { message, type, duration },
			});
			document.dispatchEvent(event);
		}

		/** DISABLED — attributes are set by the Store Selector (theme.liquid). */
		updateCartAttribute() { /* no-op on purpose */ }

		/** DISABLED — avoids double-writing attributes. */
		checkCartAttribute() { /* no-op on purpose */ }

		updateCartQty(item, newQty) {
			this.form.classList.add('processing');
			if (this.querySelector('.alert')) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty,
			});

			fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
				body,
			})
				.then((response) => {
					if (response.ok) {
						return fetch('?section_id=helper-cart');
					} else {
						throw new Error('Something went wrong');
					}
				})
				.then((response) => response.text())
				.then((text) => {
					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if (
						newQty != 0 &&
						cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`) &&
						newQty >
							parseInt(
								cartItems.querySelector(`[data-js-cart-item][data-id="${item.dataset.id}"]`).dataset.qty
							)
					) {
						let alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						alert.innerHTML = KROWN.settings.locales.cart_add_error.replace(
							'{{ title }}',
							item.dataset.title
						);
						this.form.prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					const event = new Event('cart-updated');
					this.dispatchEvent(event);
				})
				.catch((e) => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}
	}

	if (typeof customElements.get('cart-form') == 'undefined') {
		customElements.define('cart-form', CartForm);
	}
}

if (typeof CartProductQuantity !== 'function') {
	class CartProductQuantity extends HTMLElement {
		constructor() {
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput() {
			setTimeout(() => {
				document
					.getElementById('AjaxCartForm')
					.updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

	if (typeof customElements.get('cart-product-quantity') == 'undefined') {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}
}

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {
	window.refreshCart = () => {
		fetch('?section_id=helper-cart')
			.then((response) => response.text())
			.then((text) => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();

				document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				document.querySelector('[data-js-site-cart-sidebar]')?.show();

				if (document.querySelector('cart-recommendations')) {
					document.querySelector('cart-recommendations').innerHTML = '';
					document.querySelector('cart-recommendations').generateRecommendations();
				}
			});
	};
}
